import L from "leaflet";
import "leaflet-providers";
import "leaflet-pulse-icon";
import "leaflet.locatecontrol";
import "leaflet-sleep";

/**
 * Wonders Maps
 * @type {{init: maps.init}}
 */
export const maps = {
    init: function () {
        if ($('#wonder-map').length) {
            if (typeof wp !== 'undefined') {
                L.Icon.Default.imagePath = wp.n7wTemplate + '/public/images/maps/';

                /* jshint shadow:true */
                if ( wp.colorIcons ) {
                    var MarkerN7WW = L.icon.pulse({iconSize: [15, 15], color: '#005488', animate: true, heartbeat: 15}),
                    MarkerN7WN = L.icon.pulse({iconSize: [15, 15], color: '#C8D20A', animate: true, heartbeat: 15}),
                    MarkerN7WC = L.icon.pulse({iconSize: [15, 15], color: '#E76046', animate: true, heartbeat: 15});
                } else {
                    var MarkerN7WW = L.icon.pulse({iconSize: [20, 20], color: '#fff', animate: true, heartbeat: 15}),
                    MarkerN7WN = L.icon.pulse({iconSize: [20, 20], color: '#fff', animate: true, heartbeat: 15}),
                    MarkerN7WC = L.icon.pulse({iconSize: [20, 20], color: '#fff', animate: true, heartbeat: 15});
                }

                let N7WWArray = [];
                let N7WNArray = [];
                let N7WCArray = [];

                // Build the N7WW
                $.each(wp.n7ww, function (i, ob) {
                    $.each(ob, function (ind, wonder) {
                        N7WWArray.push(L.marker([wonder.lat, wonder.long], {icon: MarkerN7WW}).bindPopup(wonder.content));
                    });
                });

                // Build the N7WN
                $.each(wp.n7wn, function (i, ob) {
                      $.each(ob, function (ind, wonder) {
                        N7WNArray.push(L.marker([wonder.lat, wonder.long], {icon: MarkerN7WN}).bindPopup(wonder.content));
                      });
                });

                // Build the N7WC
                $.each(wp.n7wc, function (i, ob) {
                      $.each(ob, function (ind, wonder) {
                        N7WCArray.push(L.marker([wonder.lat, wonder.long], {icon: MarkerN7WC}).bindPopup(wonder.content));
                      });
                });

                // Overlay Maps
                const n7ww = L.layerGroup(N7WWArray);
                const n7wn = L.layerGroup(N7WNArray);
                const n7wc = L.layerGroup(N7WCArray);

                // Base Map
                let satellite = L.tileLayer.provider('HERE.satelliteDay', {
                      // noWrap: true,
                    app_id: 'KZ4MpfbVZ9Kd2CKzuzI7',
                    app_code: 'qUwSrF9rG0HfNXxd1o977w',
                });


                /* http://3.aerial.maps.cit.api.here.com/maptile/2.1/maptile/newest/satellite.day/3/3/3/256/png8?app_id=KZ4MpfbVZ9Kd2CKzuzI7&app_code=qUwSrF9rG0HfNXxd1o977w&lg=eng */
                /*
                 var satellite = L.tileLayer('http://{s}.{base}.maps.cit.api.here.com/maptile/2.1/{type}/{mapID}/{scheme}/{z}/{x}/{y}/{size}/{format}?app_id={app_id}&app_code={app_code}&lg={language}', {
                 noWrap: true,
                 attribution: 'Map &copy; 2016 <a href="http://developer.here.com">HERE</a>',
                 subdomains: '1234',
                 base: 'aerial',
                 type: 'maptile',
                 scheme: 'satellite.day',
                 app_id: 'KZ4MpfbVZ9Kd2CKzuzI7',
                 app_code: 'qUwSrF9rG0HfNXxd1o977w',
                 mapID: 'newest',
                 maxZoom: 20,
                 language: 'eng',
                 format: 'png8',
                 size: '256'
                 });
                 */


                const map = L.map('wonder-map', {
                    center: [wp.mapCenterLat, wp.mapCenterLong],
                    zoom: wp.mapZoom,
                    maxZoom: 13,
                    minZoom: 2,
                    maxBounds: L.latLngBounds([-90, -180], [90, 180]),
                    layers: [satellite, n7ww, n7wc, n7wn],

                      // false if you want an unruly map
                    sleep: true,
                      // time(ms) until map sleeps on mouseout
                    sleepTime: 750,
                      // time(ms) until map wakes on mouseover
                    wakeTime: 750,
                      // should the user receive wake instrurctions?
                    sleepNote: true,
                      // should hovering wake the map? (non-touch devices only)
                    hoverToWake: true,
                      // a message to inform users about waking the map
                    wakeMessage: 'Click or Hover to Wake',

                    sleepMessage: 'X',
                      // a constructor for a control button
                    sleepButton: L.Control.sleepMapControl,
                      // opacity for the sleeping map
                    sleepOpacity: 1,
                });

                const baseMaps = {
                    "Satellite": satellite,
                };

                const overlayMaps = {
                    "New7Wonders of the World": n7ww,
                    "New7Wonders of Nature": n7wn,
                    "New7Wonders Cities": n7wc,
                };

                map.addControl(L.control.locate({
                    icon: 'glyphicon glyphicon-record',
                    iconLoading: 'glyphicon glyphicon-hourglass',
                    iconElementTag: 'span',
                    showPopup: false,
                    circleStyle: {
                        color: '#fff',
                        fill: false,
                        clickable: false,
                        weight: 50,
                    },
                    markerStyle: {
                        clickable: false,
                        color: '#fff',
                        fillColor: '#fff',
                    },
                    locateOptions: {
                        maxZoom: 6,
                    }}));

                // TODO: We should not hide this. Let's find a better solution.
                $('.leaflet-control-attribution').hide();

                // L.control.layers(baseMaps, overlayMaps).addTo(map);
                // L.control.layers('', overlayMaps).addTo(map);
            }
        }
    },
};
